import React from 'react';

class Base extends React.Component {
    render() {
        return <section style={{ position: 'absolute', top: 0, bottom: 0, left: 0, right: 0 }} className="bg-white">
            {React.cloneElement(this.props.children, this.props)}
        </section>
    }
}

export default Base;


// WEBPACK FOOTER //
// ./src/components/layouts/base.js